const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

async function api(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const getStatus = () => api("/api/status");
export const submitAttendance = (body) => api("/api/submit", { method: "POST", body: JSON.stringify(body) });
export const adminLogin = (password) => api("/api/admin/login", { method: "POST", body: JSON.stringify({ password }) });
export const adminLogout = () => api("/api/admin/logout", { method: "POST" });
export const checkSession = () => api("/api/admin/session");
export const adminGetState = () => api("/api/admin/state");
export const adminSetEvent = (event_name) => api("/api/admin/set-event", { method: "POST", body: JSON.stringify({ event_name }) });
export const adminToggle = () => api("/api/admin/toggle", { method: "POST" });
export const adminRandomize = () => api("/api/admin/randomize-token", { method: "POST" });
